module.exports = __webpack_public_path__ + "static/media/icon-toilet.ee440811.svg";